var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import ActionModal from '../../containers/modals/hidestrategy';
import { HideStrategy } from '../types';
export const HIDE_STRATEGY_NAMES = {
    [HideStrategy.ALL_AGENTS_AWAY]: 'Hide when all agents are either away or offline',
    [HideStrategy.ALL_AGENTS_OFFLINE]: 'Hide when all agents are offline',
    [HideStrategy.NEVER]: 'Never hide',
    [HideStrategy.EXPECTED_WAITING_TIME]: 'Hide when expected waiting time is above threshold',
};
const portTranslator = (node) => {
    const ports = [];
    if (node.payload.strategy !== HideStrategy.NEVER) {
        ports.push({
            id: uuid(),
            type: 'out',
            label: 'Hidden',
            connection: node.payload.hiddenNodeId || uuid(),
        });
    }
    return [
        ...ports,
        {
            id: uuid(),
            type: 'out',
            label: 'Shown',
            connection: node.payload.shownNodeId || uuid(),
        },
    ];
};
export class HideStrategyNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        const { node: { payload: { strategy }, }, } = this.props;
        return (_jsx(FlowNode, { color: HideStrategyNode.color, icon: HideStrategyNode.icon, label: HideStrategyNode.label, text: _jsxs(Text.Paragraph, Object.assign({ clamp: 2 }, { children: ["Strategy: ", _jsx("strong", { children: HIDE_STRATEGY_NAMES[strategy] })] })), onEdit: this.triggerEdit }));
    }
}
HideStrategyNode.icon = 'hide-strategy';
HideStrategyNode.label = 'Hide Strategy';
HideStrategyNode.color = flowNodeColor.purple;
HideStrategyNode.height = FlowNode.dimensions.h + 16;
HideStrategyNode.translatePayload = formatPortsHelper(portTranslator);
HideStrategyNode.ActionModal = ActionModal;
HideStrategyNode.actionTrigger = { type: FlowNodeTypes.HIDE_STRATEGY };
HideStrategyNode.updateConnection = (node, port, newConnection) => {
    const { payload } = node;
    const fieldToUpdate = port.label === 'Shown' ? 'shownNodeId' : 'hiddenNodeId';
    return Object.assign(Object.assign({}, node), { payload: Object.assign(Object.assign({}, payload), { [fieldToUpdate]: newConnection }) });
};
__decorate([
    boundMethod
], HideStrategyNode.prototype, "triggerEdit", null);
